import * as React from 'react';
import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import {default as MuiSelect} from '@mui/material/Select';
import "./input-select.styles.css";

const TtmFormControl = styled(FormControl)({
  '& label.Mui-focused': {
    color: 'var(--color-primary)'
  },
  '&:after, &:before': {
    borderBottom: 'none'
  },
  '& .MuiSelect-icon':{
    display: "flex"
  },
  '& .MuiSelect-icon path':{
    opacity:"0.8",
    //d:`path("M8.4366 7.1016L15.0409 1.74341C15.171 1.63786 15.25 1.48701 15.25 1.32194C15.25 1.15688 15.171 1.00602 15.0409 0.900479C14.7936 0.69984 14.4128 0.69984 14.1655 0.900479L8.00037 5.90237L1.83525 0.900479C1.58795 0.69984 1.20715 0.69984 0.959847 0.900479C0.833498 1.00299 0.75 1.15424 0.75 1.32075C0.75 1.48217 0.826322 1.63582 0.961397 1.74229L7.56233 7.09774C7.56267 7.09802 7.56301 7.0983 7.56335 7.09858C7.80831 7.30027 8.19247 7.29967 8.4366 7.1016Z")`,
    color:"#878787",
    //color: '#9B9B9B',
    d: 'path("M12.4366 16.1016L19.0409 10.7434C19.171 10.6379 19.25 10.487 19.25 10.3219C19.25 10.1569 19.171 10.006 19.0409 9.90048C18.7936 9.69984 18.4128 9.69984 18.1655 9.90048L12.0004 14.9024L5.83525 9.90048C5.58795 9.69984 5.20715 9.69984 4.95985 9.90048C4.8335 10.003 4.75 10.1542 4.75 10.3208C4.75 10.4822 4.82632 10.6358 4.9614 10.7423L11.5623 16.0977C11.5627 16.098 11.563 16.0983 11.5633 16.0986C11.8083 16.3003 12.1925 16.2997 12.4366 16.1016Z")'
  },
  '& .MuiFilledInput-root':{
    "backgroundColor": "transparent"
  },
  '& .MuiSelect-filled': {
    fontFamily:'var(--font-primary), sans-serif',
    fontSize: "var(--text-medium)",
    borderBottom: "none",
    border: "1px solid var(--text-color-secondary-15)",
    borderRadius: "8px",
    background: "#fff",
    paddingTop: "18px!important",
    paddingBottom: "0",
    textAlign: "left"
  },
  '& .Mui-focused .MuiSelect-filled': {
    border: '1px solid var(--color-primary)',
    borderRadius: "8px",
    background: "#fff"
  },
  '& .MuiFilledInput-input': {
    paddingTop: "10px"
  },
  '& .MuiInputLabel-root': {
    fontFamily:'var(--font-primary), sans-serif',
    fontSize: "var(--text-medium)",
    lineHeight: "1rem"
  },
  '& .MuiFilledInput-underline:before': {
    border: 'none',
    opacity: '0',
    background: "#fff"
  },
  '& .MuiFilledInput-underline:after': {
    border: 'none',
  },
  '& div.Mui-error': {
    border: "1px solid red!important",
  }
});

export default function InputSelect(props) {
  const {id, name, autocomplete, hidden, ...others} = props;
  const givenId = id;
  const givenName = name? name: "select";
  return (
    <div className={'input-select-container '+(hidden?"hidden":"")}>
    <TtmFormControl sx={{width: '100%'}} variant='filled' {...others}>
      <InputLabel>{props.label}</InputLabel>
        <MuiSelect labelId={givenId+"_label"} id={givenId} name={givenName} sx={{width: '100%!important'}} label={props.label} className='input-text' fullWidth variant="filled" onChange={props.onChange} value={props.value} 
            inputProps={{...props}}>
          {props.data.map((menu, index)=>(
            <MenuItem 
              key={index} 
              value={menu.value}
              disabled={menu.value==="-"}
              sx={{backgroundColor: menu.value==="-"?"#ddd":""}}
              >
                {menu.label + (menu.value==="-"?"- Out of Stock":"")}
            </MenuItem>
          ))}
        </MuiSelect>
        <div className='error-message' style={{opacity:"0", display:props.no_error?"none":""}}>error</div>
    </TtmFormControl>
    </div>
  );
}